import React from 'react'

const HSEQuality = () => {
  return (
    <div>
      <h1>HSE Quality</h1>
    </div>
  )
}

export default HSEQuality